import React from "react";
import PropTypes from "prop-types";

export function PhysicalAddress({ address }) {
  return (
    <table className="table table-condensed">
      <tbody>
        <tr>
          <th className="text-right">Address Line</th>
          <td>{address.line1}</td>
        </tr>
        <tr>
          <th className="text-right">City</th>
          <td>{address.city}</td>
        </tr>
        <tr>
          <th className="text-right">State/ Province/ Region</th>
          <td>{address.state}</td>
        </tr>
        <tr>
          <th className="text-right">ZIP/ Postal Code</th>
          <td>{address.postal_code}</td>
        </tr>
        <tr>
          <th className="text-right">Country</th>
          <td>{address.country}</td>
        </tr>
      </tbody>
    </table>
  );
}

PhysicalAddress.propTypes = {
  address: PropTypes.shape({
    line1: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postal_code: PropTypes.string,
    country: PropTypes.string
  })
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/PhysicalAddress.jsx